import { filter } from 'lodash';
import { DISMISS_ALERT, SHOW_ALERT } from './constants';

export default (state = [], action) => {
  switch (action.type) {
    case DISMISS_ALERT:
      return filter(state, alert => alert.id !== action.payload.id);
    case SHOW_ALERT:
      return [...state, action.payload];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/alerts/reducer.js